export enum ConvertedReviewStatus {
    New = 'new',
    Answered = 'answered',
    AnswerChanged = 'answerChanged',
    Augmented = 'augmented',
    AnswerRejected = 'answerRejected',
}

export const convertedReviewStatusStrings = {
    [ConvertedReviewStatus.New]: 'Новый',
    [ConvertedReviewStatus.Answered]: 'Отвечен',
    [ConvertedReviewStatus.AnswerChanged]: 'Ответ изменен',
    [ConvertedReviewStatus.Augmented]: 'Дополнен',
    [ConvertedReviewStatus.AnswerRejected]: 'Ответ отклонен',
};
